import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import { ScoreColorCircle } from "@src/shared/components/ScoreColorCircle/ScoreColorCircle";
import { Tag } from "@src/shared/components/Tag/Tag";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import { getWordForm, yearsForms } from "@src/shared/utils/monthToYears";
import { Tooltip } from "@mui/material";
import clsx from "clsx";

import styles from "./styles.module.scss";

interface ICandidateMiniCard {
  request_uuid: string;
  candidate_id: string;
  scores: number | string;
  city: string;
  age: number;
  relevant_experience_years: string;
  salary: string;
  desired_position: string;
  gender: string;
  isShowNeedAtentionInfo: boolean;
  isViewed: boolean;
}

export const CandidateMiniCard = ({
  request_uuid,
  candidate_id,
  scores,
  city,
  age,
  relevant_experience_years,
  salary,
  desired_position,
  gender,
  isShowNeedAtentionInfo,
  isViewed,
}: ICandidateMiniCard) => {
  const navigate = useNavigate();

  const ageLabel = getWordForm(age, yearsForms);

  const onCandidate = () => {
    navigate(
      `/candidate?request_uuid=${request_uuid}&candidate_id=${candidate_id}`,
    );
  };

  const displayPosition =
    desired_position.length > 12
      ? `${desired_position.substring(0, 16)}...`
      : desired_position;

  return (
    <div
      className={clsx(
        styles.searchMiniresult,
        isViewed && styles.searchMiniresultViewed,
      )}
      onClick={onCandidate}
    >
      <div className={styles.leftBlock}>
        <div className={styles.viewedOpacityContent}>
          <ScoreColorCircle score={Number(scores)} />
        </div>

        {isViewed && <span className={styles.viewed}>Просмотрено</span>}
      </div>

      <div
        className={clsx(styles.miniResultPosition, styles.viewedOpacityContent)}
      >
        <Tooltip title={desired_position} arrow placement="top">
          <div className={styles.miniResultPositionTitle}>
            <span className={styles.titleText}>{displayPosition}</span>
            <span className={styles.genderIcon}>
              {gender === "Мужской" ? (
                <MaleIcon fontSize="small" sx={{ color: "#00C195" }} />
              ) : (
                <FemaleIcon fontSize="small" sx={{ color: "#00C195" }} />
              )}
            </span>
          </div>
        </Tooltip>

        {isShowNeedAtentionInfo && (
          <div className={styles.sectionAtention}>
            <div className={styles.needAtentionTitleCricle} />
            <div className={styles.needAtentionTitleText}>Требует внимания</div>
          </div>
        )}

        <div className={styles.miniResultPositionTags}>
          <Tag tagText={city} />
          {!!age && <Tag tagText={`${age} ${ageLabel}`} />}
          <Tag tagText={relevant_experience_years} />
        </div>
      </div>

      <div
        className={clsx(
          styles.miniresultLogoAndSalary,
          styles.viewedOpacityContent,
        )}
      >
        <div>
          <Avatar sx={{ backgroundColor: "#FF0002" }}>hh</Avatar>
        </div>
        <div className={styles.miniResultSalary}>{salary}</div>
      </div>
    </div>
  );
};
